/**
 * @generated SignedSource<<c8aef92d1e39453853d1257236131e47>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_ReadyToConnect$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_ConnectorSection">;
  readonly " $fragmentType": "main_softwareCodePage_ReadyToConnect";
};
export type main_softwareCodePage_ReadyToConnect$key = {
  readonly " $data"?: main_softwareCodePage_ReadyToConnect$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_ReadyToConnect">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_softwareCodePage_ReadyToConnect",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_ConnectorSection"
    }
  ],
  "type": "Query"
};

(node as any).hash = "8a6acd3e482a32da17001bba999365f4";

export default node;
